module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control",
    class: {
      'has-error': _vm.errors.has('mobile')
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mobile Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }, {
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "mobile",
      "placeholder": "Mobile Number"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer",
    class: {
      'has-error': _vm.errors.has('email')
    }
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.canChangeRole && !_vm.accountUser.driver_id) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control form-group",
    class: {
      'has-error': _vm.errors.has('role')
    }
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Primary Role")]), _vm._v(" "), _c('selectize', {
    directives: [{
      name: "validate",
      rawName: "v-validate:roleId",
      value: (_vm.roleRequired ? 'required' : ''),
      expression: "roleRequired ? 'required' : ''",
      arg: "roleId"
    }],
    attrs: {
      "name": "role",
      "options": _vm.systemAccessOptions
    },
    model: {
      value: (_vm.roleId),
      callback: function($$v) {
        _vm.roleId = $$v
      },
      expression: "roleId"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('strong', [_vm._v("Last access:")]), _vm._v(" " + _vm._s(_vm.lastLogin) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), (_vm.isDriver && (_vm.accountUser.driver_profile.id || _vm.loggedInUserIsAdmin)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-lg-4"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _vm._t("cropper")], 2)]), _vm._v(" "), (_vm.loggedInUserIsAdmin) ? _c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h3', [_vm._v("Current Carriers")]), _vm._v(" "), (_vm.carriers && _vm.carriers.length && _vm.carriers[0].id) ? _c('ul', _vm._l((_vm.carriers), function(carrier) {
    return _c('li', {
      attrs: {
        "trick-by": _vm.id
      }
    }, [_vm._v("\n                " + _vm._s(carrier.profile.account_name || carrier.profile.company_name) + "\n                "), _c('a', {
      staticClass: "pull-right",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.syncCarriers(carrier.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times",
      attrs: {
        "id": ("carrier-" + (carrier.id))
      }
    })])])
  })) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Add Carrier")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "options": _vm.initialUserOptions,
      "name": "user",
      "fetch-results": _vm.fetchUserResults
    },
    model: {
      value: (_vm.user_id),
      callback: function($$v) {
        _vm.user_id = $$v
      },
      expression: "user_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-sm text-right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.syncCarriers(null)
      }
    }
  }, [_vm._v("Add")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-lg-8"
  }, [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Drivers Licence")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.licence),
      expression: "licence"
    }, {
      name: "float-label",
      rawName: "v-float-label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Drivers Licence",
      "disabled": !_vm.loggedInUserIsAdmin
    },
    domProps: {
      "value": (_vm.licence)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.licence = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Licence Expiry")]), _vm._v(" "), _c('date-range', {
    directives: [{
      name: "float-label",
      rawName: "v-float-label"
    }],
    attrs: {
      "name": "expiry",
      "single-date-picker": true,
      "disabled": !_vm.loggedInUserIsAdmin,
      "opens": "right"
    },
    model: {
      value: (_vm.licenceExpiry),
      callback: function($$v) {
        _vm.licenceExpiry = $$v
      },
      expression: "licenceExpiry"
    }
  })], 1)])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-79b52035"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserDetails.vue
// module id = 1048
// module chunks = 0